import { useEffect } from 'react';
import { Col, Row, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { AppDispatch, RootState } from '../../app/store';
import LoadingIndicator from '../loading/LoadingIndicator';
import { useAuth } from '../signin/auth';
import { listChecklists, selectAllChecklists } from './checklistsSlice';
import { Checklist } from './types';

function ListChecklists() {
  const auth = useAuth();
  const dispatch = useDispatch<AppDispatch>();
  const checklists = useSelector((state: RootState) => selectAllChecklists(state));
  const checklistsStatus = useSelector((state: RootState) => state.checklists.status)
  const checklistsError = useSelector((state: RootState) => state.checklists.error)

  useEffect(() => {
    if (auth.authToken) {
      dispatch(listChecklists({ authToken: auth.authToken }));
    }
  }, [dispatch, auth.authToken]);

  return (
    <div>
      {checklistsStatus === 'loading' && <LoadingIndicator />}
      {checklistsStatus === 'failed' && <div>{checklistsError}</div>}
      <>
        {checklists.length > 0 && (
          <Row className="mt-3">
            <Col>
              <Table striped>
                <thead>
                  <tr>
                    <th>Checklist</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {checklists.map((checklist: Checklist) => {
                    return (
                      <tr key={checklist.id}>
                        <td>
                          <Link to={`/checklist/${checklist.id}`}>{checklist.name}</Link>
                        </td>
                        <td>
                          <Link to={`/checklist/${checklist.id}/edit`}>Edit</Link>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table>
            </Col>
          </Row>
        )}
      </>
    </div>
  );
}

export default ListChecklists;